import React, {useState, useEffect} from 'react'

function ApiCall({endPoint}) {

  useEffect(() => {
    fetchItems();
  }, [])

  //set items as state
  const [items, setItems] = useState([])

  const fetchItems = async () => {
    const data = await fetch(
      'https://jsonplaceholder.typicode.com/posts'
    );
    const items = await data.json();
    console.log(items)
    console.log(typeof(items))
    setItems(items)
  }
      
      return (
        
        <React.Fragment>
    
                <style type="text/css">
                  {`
                      h3 {
                        padding: 1.3rem;
                      }
                      
                      p{
                        padding: 1.3rem;
                      }
    
                      .post {
                        
                        margin: 5px 0 5px 0;
                        border-radius: 5px;
    
                      }
                  `}
                </style>
    
            {items.map(item => (
      
                <div className=" post shadow p-3 mb-5 bg-white rounded" key={item.id}>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </ div>
            ))}
        </React.Fragment>
        
      )
    
}

export default ApiCall
